(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["A3D-marquee-cyber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('a3d-cyber-marquee')) return;

    class A3DCyberMarquee extends HTMLElement {
      connectedCallback() {
        if (this._initialized || this._startFrame) return;
        this._startFrame = requestAnimationFrame(() => {
          this._startFrame = 0;
          if (this.isConnected) this.init();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._startFrame);
        cancelAnimationFrame(this._scrollFrame);
        clearTimeout(this._resizeTimer);
        if (this._controller) this._controller.abort();
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._menuObserver) this._menuObserver.disconnect();
        this._initialized = false;
        this._startFrame = 0;
        this._scrollFrame = 0;
      }

      init() {
        this._track = this.querySelector('[data-mq-track]');
        this._viewport = this.querySelector('[data-mq-viewport]');
        const item = this.querySelector('.a3d-mq__item');
        if (!this._track || !this._viewport || !item) return;

        this._initialized = true;
        this._model = item.cloneNode(true);
        this.formatBracketText(this._model);
        this._key = null;
        this._selectedBlock = null;
        this._sectionSelected = false;
        this._controller = new AbortController();
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this._controller.signal;
        const refresh = () => this.queueRefresh();
        const schedule = () => this.queueScroll();

        window.addEventListener('resize', refresh, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('load', refresh, { signal });
        this.addEventListener('load', event => {
          if (event.target.tagName === 'IMG') refresh();
        }, { capture: true, signal });
        this._motion.addEventListener('change', () => this.refresh(true), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) { this.refresh(); this.queueScroll(); }
        }, { signal });

        if (this.dataset.designMode === 'true') {
          document.addEventListener('shopify:block:select', event => {
            if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
            this._selectedBlock = event.detail.blockId;
            this.classList.add('is-editor-paused');
            this.refresh(true);
          }, { signal });
          document.addEventListener('shopify:block:deselect', event => {
            if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
            this._selectedBlock = null;
            this.classList.toggle('is-editor-paused', this._sectionSelected);
            this.refresh(true);
          }, { signal });
          document.addEventListener('shopify:section:select', event => {
            if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
            this._sectionSelected = true;
            this.classList.add('is-editor-paused');
          }, { signal });
          document.addEventListener('shopify:section:deselect', event => {
            if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
            this._sectionSelected = false;
            this.classList.toggle('is-editor-paused', Boolean(this._selectedBlock));
          }, { signal });
        }

        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(refresh);
          this._resizeObserver.observe(this._viewport);
        }
        if (this.isFixedHome() && this.dataset.menuSelector.trim() && 'MutationObserver' in window) {
          this._menuObserver = new MutationObserver(records => {
            if (records.some(record => !this.contains(record.target))) schedule();
          });
          this._menuObserver.observe(document.body, {
            subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-expanded']
          });
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { if (this._initialized && this.isConnected) refresh(); });
        }
        this.refresh(true);
        this.updateScroll();
      }

      formatBracketText(scope) {
        scope.querySelectorAll('[data-mq-format]').forEach(node => {
          const source = node.getAttribute('data-mq-source') || '';
          const fragment = document.createDocumentFragment();
          const pattern = /\[([^\[\]]+)\]/g;
          let cursor = 0;
          let match;
          while ((match = pattern.exec(source)) !== null) {
            fragment.appendChild(document.createTextNode(source.slice(cursor, match.index)));
            const highlight = document.createElement('span');
            highlight.className = 'a3d-mq__highlight';
            highlight.textContent = match[1];
            fragment.appendChild(highlight);
            cursor = pattern.lastIndex;
          }
          fragment.appendChild(document.createTextNode(source.slice(cursor)));
          node.replaceChildren(fragment);
        });
      }

      applySchedule() {
        const message = this._model.querySelector('[data-mq-fallback]');
        const urgency = this._model.querySelector('.a3d-mq__urgency');
        if (urgency) urgency.hidden = !message || !message.textContent.trim();
        return 'manual';
      }

      queueRefresh() {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.refresh(), 100);
      }

      refresh(force) {
        if (!this._initialized || !this.isConnected) return;
        const key = this.applySchedule();
        const width = this._viewport.clientWidth;
        const item = this._track.querySelector('.a3d-mq__item');
        const itemWidth = item ? item.getBoundingClientRect().width : 0;
        if (force || key !== this._key || width !== this._width || Math.abs(itemWidth - this._itemWidth) > .25) {
          this._key = key;
          this.build();
        }
      }

      cloneItem(keepEditorAttributes) {
        const copy = this._model.cloneNode(true);
        if (!keepEditorAttributes) copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
        return copy;
      }

      readableText(node) {
        if (node.nodeType === Node.TEXT_NODE) return node.textContent;
        if (node.nodeType !== Node.ELEMENT_NODE || node.hidden) return '';
        if (node.tagName === 'IMG') return node.alt;
        return Array.from(node.childNodes).map(child => this.readableText(child)).join('');
      }

      build() {
        this.classList.remove('is-ready');
        const group = document.createElement('div');
        group.className = 'a3d-mq__group';
        group.appendChild(this.cloneItem(true));
        this._track.replaceChildren(group);
        this._width = this._viewport.clientWidth;
        this._itemWidth = group.firstElementChild.getBoundingClientRect().width;
        if (!this._width || !this._itemWidth) return;

        const count = this._motion.matches ? 1 : Math.max(2, Math.ceil(this._width / this._itemWidth) + 1);
        const fragment = document.createDocumentFragment();
        for (let i = 1; i < count; i++) fragment.appendChild(this.cloneItem(false));
        group.appendChild(fragment);
        const distance = group.getBoundingClientRect().width;
        if (!this._motion.matches) {
          const duplicate = group.cloneNode(true);
          duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          this._track.appendChild(duplicate);
        }
        const speed = Math.max(1, Number(this.dataset.speed) || 50);
        this._track.style.setProperty('--mq-duration', (distance / speed) + 's');
        // Forzar el reinicio solo cuando cambian el mensaje o las medidas.
        void this._track.offsetWidth;
        this.classList.add('is-ready');
        const accessible = this.querySelector('[data-mq-accessible]');
        if (accessible) accessible.textContent = this.readableText(this._model).replace(/\s+/g, ' ').trim();
      }

      isFixedHome() {
        return this.dataset.isHome === 'true' && this.dataset.fixedHome === 'true' && this.dataset.designMode !== 'true';
      }

      menuVisible() {
        const selector = this.dataset.menuSelector.trim();
        if (!selector) return false;
        let menus;
        try { menus = document.querySelectorAll(selector); } catch (error) { return false; }
        return Array.from(menus).some(menu => {
          if (this.contains(menu)) return false;
          const style = getComputedStyle(menu);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          const rect = menu.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        });
      }

      queueScroll() {
        if (this._scrollFrame) return;
        this._scrollFrame = requestAnimationFrame(() => { this._scrollFrame = 0; this.updateScroll(); });
      }

      updateScroll() {
        if (!this._initialized) return;
        if (!this.isFixedHome()) { this.classList.remove('is-hidden'); return; }
        const mobile = matchMedia('(max-width: 767px)').matches;
        const value = Number(mobile ? this.dataset.scrollMobile : this.dataset.scrollDesktop);
        const threshold = Number.isFinite(value) ? Math.max(0, value) : (mobile ? 10000 : 8500);
        this.classList.toggle('is-hidden', window.scrollY > threshold || this.menuVisible());
      }
    }

    customElements.define('a3d-cyber-marquee', A3DCyberMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["A3D-popup-custom"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('shopify-promo-popup')) return;

  const prefix = 'shopify-promo:v1:';
  const memory = new Map();
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return memory.get(key) || null; } },
    set(key, value) { memory.set(key, value); try { sessionStorage.setItem(key, value); } catch (_) {} },
    remove(key) { memory.delete(key); try { sessionStorage.removeItem(key); } catch (_) {} }
  };
  const pageURL = value => { const url = new URL(value, location.href); url.hash = ''; return url.href; };

  // Preserve internal links even when a theme uses a no-referrer policy.
  const pendingKey = prefix + 'internal-navigation';
  let internalNavigation = false;
  try {
    const pending = JSON.parse(storage.get(pendingKey) || 'null');
    internalNavigation = !!pending && pageURL(pending.url) === pageURL(location.href)
      && Date.now() - pending.at >= 0 && Date.now() - pending.at < 30000;
  } catch (_) {}
  storage.remove(pendingKey);
  let sameSiteReferrer = false;
  try { sameSiteReferrer = new URL(document.referrer).origin === location.origin; } catch (_) {}
  const navigationType = performance.getEntriesByType('navigation')[0]?.type || 'navigate';
  const newVisit = navigationType === 'navigate' && !sameSiteReferrer && !internalNavigation;
  const resetKeys = new Set();

  function rememberInternalNavigation(url) {
    try {
      const target = new URL(url, location.href);
      if (target.origin !== location.origin) return;
      storage.set(pendingKey, JSON.stringify({ url: pageURL(target.href), at: Date.now() }));
    } catch (_) {}
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!(link instanceof HTMLAnchorElement) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey
      || event.shiftKey || event.altKey || link.download || (link.target && link.target !== '_self')) return;
    if (pageURL(link.href) !== pageURL(location.href)) rememberInternalNavigation(link.href);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented || (form.target && form.target !== '_self')) return;
    if ((form.method || 'get').toLowerCase() === 'get') {
      const url = new URL(form.action, location.href);
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form)) if (typeof value === 'string') params.append(key, value);
      if (event.submitter?.name) params.append(event.submitter.name, event.submitter.value);
      url.search = params.toString();
      rememberInternalNavigation(url.href);
    } else rememberInternalNavigation(form.action);
  });

  function parseDate(value, offset) {
    const date = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((value || '').trim());
    const zone = /^([+-])(\d{2}):(\d{2})$/.exec((offset || '').trim());
    if (!date || !zone) return NaN;
    const [year, month, day, hour, minute] = date.slice(1).map(Number);
    const zoneHours = Number(zone[2]), zoneMinutes = Number(zone[3]);
    if (year < 2000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59
      || zoneHours > 14 || zoneMinutes > 59 || (zoneHours === 14 && zoneMinutes !== 0)) return NaN;
    const wallClock = Date.UTC(year, month - 1, day, hour, minute);
    const check = new Date(wallClock);
    if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
    const shift = (zoneHours * 60 + zoneMinutes) * 60000 * (zone[1] === '+' ? 1 : -1);
    return wallClock - shift;
  }

  class PromoPopup extends HTMLElement {
    connectedCallback() {
      // The Shopify bundle can upgrade elements before their children have been parsed.
      queueMicrotask(() => { if (this.isConnected && !this.controller) this.initialize(); });
    }

    initialize() {
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('.promo-image');
      this.counter = this.querySelector('.promo-countdown');
      this.content = this.querySelector('.promo-content');
      this.progress = this.querySelector('.promo-progress');
      this.autoCloseEnabled = this.dataset.autoClose === 'true';
      this.autoCloseDuration = Number(this.dataset.autoCloseSeconds) * 1000;
      this.autoCloseValid = !this.autoCloseEnabled || (Number.isInteger(this.autoCloseDuration / 1000)
        && this.autoCloseDuration >= 1000 && this.autoCloseDuration <= 3600000);
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.key = prefix + 'dismissed:' + this.dataset.sectionId;
      this.countdownKey = prefix + 'countdown:' + this.dataset.sectionId;
      this.designMode = !!window.Shopify?.designMode;
      this.preview = this.designMode && this.dataset.preview === 'true';
      if (!this.designMode && newVisit && !resetKeys.has(this.key)) {
        storage.remove(this.key);
        storage.remove(this.countdownKey);
        resetKeys.add(this.key);
      }
      this.dismissed = !this.designMode && storage.get(this.key) === '1';
      this.start = parseDate(this.dataset.start, this.dataset.offset);
      this.end = parseDate(this.dataset.end, this.dataset.offset);
      this.valid = Number.isFinite(this.start) && Number.isFinite(this.end) && this.end > this.start;
      const hours = Number(this.dataset.countdownHours);
      const minutes = Number(this.dataset.countdownMinutes);
      const seconds = Number(this.dataset.countdownSeconds);
      this.duration = (hours * 3600 + minutes * 60 + seconds) * 1000;
      this.durationValid = Number.isInteger(hours) && hours >= 0 && hours <= 8760
        && Number.isInteger(minutes) && minutes >= 0 && minutes < 60
        && Number.isInteger(seconds) && seconds >= 0 && seconds < 60 && this.duration > 0;
      this.fixedEnd = parseDate(this.dataset.countdownEnd, this.dataset.offset);
      this.countdownValid = this.dataset.countdownMode === 'fixed'
        ? Number.isFinite(this.fixedEnd) : this.durationValid;
      this.countdownSignature = JSON.stringify([this.dataset.countdownMode, this.duration]);
      this.countdownDeadline = null;
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(name => this.querySelector('[data-' + name + ']'));
      this.querySelector('.promo-close').addEventListener('click', () => this.dismiss(), options);
      this.querySelector('.promo-cta')?.addEventListener('click', event => {
        if (!event.defaultPrevented) this.dismiss();
      }, options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dismiss(); }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) { this.stopAutoClose(); this.unlockScroll(); } }, options);
      window.addEventListener('resize', () => this.fit(), options);
      window.visualViewport?.addEventListener('resize', () => this.fit(), options);
      window.addEventListener('pageshow', () => {
        if (!this.designMode && storage.get(this.key) === '1') this.dismissed = true;
        this.checkAutoClose();
        this.update();
      }, options);
      document.addEventListener('visibilitychange', () => { this.checkAutoClose(); this.update(); }, options);
      const section = this.closest('.shopify-section');
      section?.addEventListener('shopify:section:select', () => {
        if (this.preview) { this.dismissed = false; this.update(); }
      }, options);
      this.image?.addEventListener('load', () => this.update(), options);
      this.image?.addEventListener('error', () => { this.close(); this.note('No se pudo cargar la imagen. Selecciona otra imagen.'); }, options);
      this.observer = new ResizeObserver(() => this.positionCountdown());
      this.observer.observe(this.content);
      if (this.image) this.observer.observe(this.image);
      this.update();
    }

    note(message) {
      const note = this.querySelector('[data-note]');
      if (note) { note.textContent = message; note.hidden = !message; }
    }

    update() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      if (!this.image) { this.note('Selecciona una imagen para el popup.'); return; }
      if (!this.valid) this.note('Completa inicio y término con formato AAAA-MM-DD HH:mm y zona UTC ±HH:mm. El término debe ser posterior al inicio.');
      else if (!this.countdownValid) this.note('Configura una duración mayor que cero o una fecha válida para el countdown independiente.');
      else if (!this.autoCloseValid) this.note('El cierre automático debe durar entre 1 y 3600 segundos enteros.');
      else if (this.preview) this.note('Vista previa: se ignoran las fechas y el cierre de la visita. Desactiva la vista previa para comprobar la programación.');
      else this.note('');
      if (this.dismissed || (!this.preview && (this.dataset.enabled !== 'true' || !this.valid || !this.countdownValid || !this.autoCloseValid))) { this.close(); return; }
      const now = Date.now();
      if (!this.preview && now >= this.end) { this.close(); return; }
      if (!this.preview && now < this.start) {
        this.close();
        this.timer = setTimeout(() => this.update(), Math.min(this.start - now, 60000));
        return;
      }
      if (!this.image.complete || !this.image.naturalWidth) return;
      if (document.hidden && !this.dialog.open) return;
      if (this.countdownDeadline === null) {
        if (this.dataset.countdownMode === 'fixed' && Number.isFinite(this.fixedEnd)) {
          this.countdownDeadline = this.fixedEnd;
        } else {
          let saved = null;
          if (!this.designMode) {
            try { saved = JSON.parse(storage.get(this.countdownKey) || 'null'); } catch (_) {}
          }
          this.countdownDeadline = saved?.signature === this.countdownSignature && Number.isFinite(saved.deadline)
            ? saved.deadline : now + (this.durationValid ? this.duration : 2 * 3600000);
          if (!this.designMode) storage.set(this.countdownKey, JSON.stringify({ signature: this.countdownSignature, deadline: this.countdownDeadline }));
        }
      }
      const total = Math.max(0, Math.ceil((this.countdownDeadline - now) / 1000));
      if (total === 0 && this.dataset.onExpire === 'close' && !this.preview) { this.dismiss(); return; }
      const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
      values.forEach((value, index) => {
        const text = String(value).padStart(2, '0');
        if (this.fields[index].textContent !== text) this.fields[index].textContent = text;
      });
      this.counter.setAttribute('aria-label', `Tiempo restante: ${values[0]} días, ${values[1]} horas, ${values[2]} minutos y ${values[3]} segundos`);
      this.fit();
      if (!this.dialog.open) {
        this.focusBefore = document.activeElement;
        this.dialog.showModal();
        this.scrollBefore = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.startAutoClose();
      }
      this.positionCountdown();
      // Publication dates and the countdown have separate deadlines.
      const nextCountdownTick = total > 0 ? Math.min(1000, this.countdownDeadline - now) : 60000;
      const nextPublicationTick = this.preview ? 60000 : this.end - now;
      this.timer = setTimeout(() => this.update(), Math.max(1, Math.min(nextCountdownTick, nextPublicationTick)));
    }

    fit() {
      if (!this.image?.naturalWidth) return;
      const viewport = window.visualViewport;
      const availableWidth = Math.max(1, (viewport?.width || window.innerWidth) - 32);
      const availableHeight = Math.max(1, (viewport?.height || window.innerHeight) - 32);
      const mobileImage = window.matchMedia('(max-width: 749px)').matches
        && Number(this.dataset.mobileImageWidth) > 0 && Number(this.dataset.mobileImageHeight) > 0;
      const imageWidth = Number(mobileImage ? this.dataset.mobileImageWidth : this.dataset.imageWidth) || this.image.naturalWidth;
      const imageHeight = Number(mobileImage ? this.dataset.mobileImageHeight : this.dataset.imageHeight) || this.image.naturalHeight;
      const ratio = imageWidth / imageHeight;
      this.dialog.style.width = Math.min(Number(this.dataset.maxWidth), imageWidth, availableWidth, availableHeight * ratio) + 'px';
      this.positionCountdown();
    }

    positionCountdown() {
      if (!this.dialog.open || !this.counter) return;
      const imageRect = this.image.getBoundingClientRect();
      const width = imageRect.width, height = imageRect.height;
      if (!width || !height) return;
      const gap = Math.min(8, width * .02, height * .02);
      const scale = Math.min(1, (width - gap * 2) / this.content.offsetWidth, (height - gap * 2) / this.content.offsetHeight);
      const halfWidth = this.content.offsetWidth * scale / 2, halfHeight = this.content.offsetHeight * scale / 2;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const x = Number(mobile ? this.dataset.mobileX : this.dataset.x) / 100;
      const y = Number(mobile ? this.dataset.mobileY : this.dataset.y) / 100;
      const clamp = (value, low, high) => Math.max(low, Math.min(value, high));
      let centerX = clamp(width * x, halfWidth + gap, width - halfWidth - gap);
      // The position settings still refer to the countdown center; the button follows underneath.
      const belowCounter = (this.content.offsetHeight - this.counter.offsetHeight) * scale / 2;
      let centerY = clamp(height * y + belowCounter, halfHeight + gap, height - halfHeight - gap);
      const buttonRect = this.querySelector('.promo-close').getBoundingClientRect();
      const buttonLeft = buttonRect.left - imageRect.left, buttonBottom = buttonRect.bottom - imageRect.top;
      if (centerX + halfWidth > buttonLeft - gap && centerY - halfHeight < buttonBottom + gap) {
        if (buttonBottom + halfHeight * 2 + gap * 2 <= height) centerY = buttonBottom + gap + halfHeight;
        else if (buttonLeft - halfWidth * 2 - gap * 2 >= 0) centerX = buttonLeft - gap - halfWidth;
      }
      this.content.style.left = centerX + 'px';
      this.content.style.top = centerY + 'px';
      this.content.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }

    startAutoClose() {
      this.stopAutoClose();
      if (!this.autoCloseEnabled || !this.autoCloseValid) return;
      this.autoCloseDeadline = performance.now() + this.autoCloseDuration;
      if (this.progress) {
        this.progress.hidden = false;
        this.progressAnimation = this.progress.querySelector('.promo-progress-fill').animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: this.autoCloseDuration, easing: 'linear', fill: 'forwards' }
        );
      }
      this.autoCloseTimer = setTimeout(() => this.checkAutoClose(), this.autoCloseDuration);
    }

    checkAutoClose() {
      if (!this.dialog?.open || this.autoCloseDeadline == null) return;
      clearTimeout(this.autoCloseTimer);
      const remaining = this.autoCloseDeadline - performance.now();
      if (remaining <= 0) this.dismiss('automatic');
      else this.autoCloseTimer = setTimeout(() => this.checkAutoClose(), remaining);
    }

    stopAutoClose() {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseDeadline = null;
      this.progressAnimation?.cancel();
      this.progressAnimation = null;
      if (this.progress) this.progress.hidden = true;
    }

    dismiss(reason = 'manual') {
      this.dismissed = true;
      if (!this.designMode) storage.set(this.key, '1');
      clearTimeout(this.timer);
      this.close();
      if (reason === 'automatic') this.dispatchEvent(new CustomEvent('promo:auto-close', { bubbles: true }));
    }

    unlockScroll() {
      if (this.scrollLocked) {
        document.documentElement.style.overflow = this.scrollBefore;
        this.scrollLocked = false;
      }
    }

    close() {
      this.stopAutoClose();
      if (this.dialog?.open) {
        this.dialog.close();
        this.unlockScroll();
        if (this.focusBefore?.isConnected) this.focusBefore.focus({ preventScroll: true });
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.close();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('shopify-promo-popup', PromoPopup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["A3D-video-top-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('a3d-product-hero')) return;
  customElements.define('a3d-product-hero', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      if (!this.querySelector('.a3d-ph__content')) {
        this._startFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.connectedCallback();
        });
        return;
      }
      this._connected = true;
      this._events = new AbortController();
      const signal = this._events.signal;
      this._mobile = window.matchMedia('(max-width: 767px)');
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._userChoice = null;
      this._inView = false;
      this._videos = [...this.querySelectorAll('[data-ph-video]')];
      this._toggle = this.querySelector('[data-ph-video-toggle]');
      this._videos.forEach(video => {
        video.muted = true;
        video.addEventListener('loadeddata', () => video.classList.add('is-ready'), { signal });
        video.addEventListener('playing', () => {
          video.classList.add('is-ready');
          if (video !== this._activeVideo || !this._canPlay()) video.pause();
          this._paintToggle();
        }, { signal });
        video.addEventListener('pause', () => this._paintToggle(), { signal });
        video.addEventListener('error', () => {
          video.dataset.phFailed = 'true';
          video.classList.remove('is-ready');
          this._syncVideo();
        }, { signal });
      });
      if (this._toggle) {
        this._toggle.addEventListener('click', () => {
          this._userChoice = !this._playIntent();
          this._syncVideo();
        }, { signal });
      }
      this._mobile.addEventListener('change', () => this._syncVideo(), { signal });
      this._motion.addEventListener('change', () => this._syncVideo(), { signal });
      document.addEventListener('visibilitychange', () => this._syncVideo(), { signal });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._inView = entries[0].isIntersecting;
          this._syncVideo();
        }, { threshold: 0 });
        this._observer.observe(this);
      } else {
        this._inView = true;
      }
      const more = this.querySelector('[data-ph-more]');
      if (more) more.addEventListener('click', () => this._scrollMore(), { signal });
      this._syncVideo();
    }
    disconnectedCallback() {
      if (this._startFrame) cancelAnimationFrame(this._startFrame);
      this._events?.abort();
      this._observer?.disconnect();
      this._videos?.forEach(video => video.pause());
      this._connected = false;
    }
    _playIntent() { return this._userChoice ?? !this._motion.matches; }
    _canPlay() { return this._playIntent() && this._inView && !document.hidden; }
    _hydrate(video) {
      if (video.dataset.phLoaded) return;
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      video.dataset.phLoaded = 'true';
      video.load();
    }
    _syncVideo() {
      const device = this._mobile.matches ? 'mobile' : 'desktop';
      this._activeVideo = this._videos.find(video => video.dataset.phVideo === device && video.dataset.phFailed !== 'true' && video.dataset.phEnabled !== 'false');
      this._videos.forEach(video => { if (video !== this._activeVideo) video.pause(); });
      if (this._activeVideo) {
        if (this._canPlay()) {
          const video = this._activeVideo;
          this._hydrate(video);
          const attempt = video.play();
          if (attempt?.catch) attempt.catch(error => {
            // AbortError is expected when the viewport/device changes during loading.
            if (video !== this._activeVideo || error.name === 'AbortError') return;
            if (error.name === 'NotAllowedError') this._userChoice = false;
            this._paintToggle();
          });
        } else this._activeVideo.pause();
      }
      this._paintToggle();
    }
    _paintToggle() {
      if (!this._toggle) return;
      this._toggle.hidden = !this._activeVideo;
      const playing = Boolean(this._activeVideo && this._canPlay());
      const label = playing ? 'Pausar video' : 'Reproducir video';
      this._toggle.setAttribute('aria-label', label);
      this._toggle.setAttribute('title', label);
      this._toggle.querySelector('[data-ph-pause]').hidden = !playing;
      this._toggle.querySelector('[data-ph-play]').hidden = playing;
    }
    _scrollMore() {
      const anchor = (this.dataset.phMoreTarget || '').trim().replace(/^#/, '');
      let target = anchor ? document.getElementById(anchor) : null;
      if (target && (target === this || this.contains(target))) return;
      if (!target && !anchor) {
        const section = this.closest('.shopify-section') || this;
        target = section.nextElementSibling;
        while (target && (/^(SCRIPT|STYLE|TEMPLATE)$/.test(target.tagName) || target.hidden || !target.getClientRects().length)) {
          target = target.nextElementSibling;
        }
      }
      if (target) target.scrollIntoView({ behavior: this._motion.matches ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
